import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { switchCustomerInStorage } from "../customerStorage";
import { isValidInternalPath } from "../internalPath.ts";

function withFromEmailMarker(path: string): string {
    return path + (path.includes("?") ? "&" : "?") + "fromEmail=true";
}

function parseRedirectUrl(): { customerId: string | null; redirectUrl: string | null } {
    const pathname = window.location.pathname;
    const match = pathname.match(/^\/customer-redirect\/([a-f0-9-]+)$/i);

    if (!match) {
        return { customerId: null, redirectUrl: null };
    }

    const customerId = match[1];
    const searchParams = new URLSearchParams(window.location.search);
    const redirectUrl = searchParams.get("redirectUrl");

    return { customerId, redirectUrl };
}

export function useCustomerRedirectWrapper() {
    const navigate = useNavigate();
    const [hasRedirected, setHasRedirected] = useState(false);

    const isSignInCallback = window.location.pathname === "/privacy/sign-in-callback";
    const { customerId, redirectUrl } = parseRedirectUrl();
    const isRedirectUrl = customerId !== null;

    useEffect(() => {
        if (isRedirectUrl && !hasRedirected) {
            const targetPath = redirectUrl && isValidInternalPath(redirectUrl) ? withFromEmailMarker(redirectUrl) : "/";

            // Multi-customer users: check if switching customer
            const currentCustomerId = localStorage.getItem("customerId");

            if (currentCustomerId !== customerId) {
                switchCustomerInStorage(customerId);
                setHasRedirected(true);
                window.location.href = window.location.origin + targetPath;
            } else {
                navigate(targetPath, { replace: true });
                setHasRedirected(true);
            }
        }
    }, [isRedirectUrl, customerId, redirectUrl, navigate, hasRedirected]);

    return {
        isLoading: isSignInCallback || (isRedirectUrl && !hasRedirected),
    };
}
